<template>
  <ColorPicker :value="value" :colors="colors" variant="inline" @change="handleChange" />
</template>

<script setup>
import ColorPicker from "components/jiffy/vue-product-details-dtf/ColorPicker.vue";

const colors = [
  "#FFFFFF",
  "#000000",
  "#D50132",
  "#FA4617",
  "#FEB414",
  "#1261A9",
  "#432F92",
  "#008080",
  "#B6E4E4",
  "#C7B1EA",
  "#FDA398"
];

defineProps({
  value: [String, null]
});

const emit = defineEmits(["change"]);

const handleChange = value => {
  emit("change", value);
};
</script>
